module.exports = __webpack_public_path__ + "1792395595471/images/socicon.a35b657.svg";